'use client'

import { Button, cn, Hero, RightTopArrow } from '@desoutter/uikit'
import Image from 'next/image'
import { HomeHeroFragment } from './HomeHero.generated'
import { Image as DatoImage } from 'react-datocms'
import DatoLink from '@/components/DatoLink/DatoLink'
import { InternalOrExternalLinkFragment } from '@/graphql/fragments/ExternalOrInternalLink.generated'
import { useLocaleBanner } from '@/hooks/useLocaleBanner'
import { CSSProperties } from 'react'

type HomeHeroProps = {
	fragment: HomeHeroFragment
}

const HomeHero = ({ fragment }: HomeHeroProps) => {
	const showBanner = useLocaleBanner()
	return (
		<div
			className={cn(
				'relative pt-[calc(var(--padding-mobile))] md:pt-[calc(var(--padding-desktop))]',
			)}
			style={
				{
					'--padding-mobile': showBanner
						? 'calc(var(--height-banner-mobile) + var(--height-header))'
						: 'var(--height-header)',
					'--padding-desktop': showBanner
						? 'calc(var(--height-banner-desktop) + var(--height-header))'
						: 'var(--height-header)',
				} as CSSProperties
			}
		>
			<DatoImage
				data={fragment.heroImage.responsiveImage}
				layout="fill"
				objectFit="cover"
				className="absolute top-0 max-h-[1000px] min-h-[600px]"
				priority
				sizes="100vw"
			/>
			<Image
				src="/images/linear-mask.png"
				alt="linear-mask"
				fill
				style={{ objectFit: 'cover' }}
				className="absolute bottom-0 w-full"
				priority
			/>
			<Hero
				title={fragment.heroTitle}
				description={fragment.heroDescription}
				cta={[
					<DatoLink
						key={fragment.ctaLink.id}
						fragment={fragment.ctaLink as InternalOrExternalLinkFragment}
					>
						<Button
							name={fragment.ctaLink.label}
							size="lg"
							title={fragment.ctaLink.label}
							icon={RightTopArrow}
							className="w-fit"
						>
							{fragment.ctaLink.label}
						</Button>
					</DatoLink>,
				]}
			/>
		</div>
	)
}

export default HomeHero
